import { z } from './utils/zod.js';
export const AUDIT_TRAIL_DOCUMENT_VIEWED = 'document.viewed';
export const auditTrailDocumentViewedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_DOCUMENT_VIEWED),
    payload: z.object({
        documentId: z.string().uuid(),
        value: z.string(),
        userName: z.string().optional(),
        signerName: z.string().optional(),
    }),
});
export const AUDIT_TRAIL_DOCUMENT_DOWNLOADED = 'document.downloaded';
export const auditTrailDocumentDownloadedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_DOCUMENT_DOWNLOADED),
    payload: z.object({
        documentId: z.string().uuid(),
        value: z.string(),
        userName: z.string().optional(),
        signerName: z.string().optional(),
    }),
});
export const AUDIT_TRAIL_SIGNING_STARTED = 'signing.started';
export const auditTrailSigningStartedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGNING_STARTED),
    payload: z.object({
        userName: z.string(),
    }),
});
export const AUDIT_TRAIL_SIGNING_EXPIRED = 'signing.expired';
export const auditTrailSigningExpiredSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGNING_EXPIRED),
    payload: z.object({}),
});
export const AUDIT_TRAIL_SIGNING_COMPLETED = 'signing.completed';
export const auditTrailSigningCompletedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGNING_COMPLETED),
    payload: z.object({
        archivedAt: z.string(),
    }),
});
export const AUDIT_TRAIL_SIGN_STARTED = 'sign.started';
export const auditTrailSignStartedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGN_STARTED),
    payload: z.object({
        signerId: z.string().uuid(),
        name: z.string(),
    }),
});
export const AUDIT_TRAIL_SIGN_ABORTED = 'sign.aborted';
export const auditTrailSignAbortedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGN_ABORTED),
    payload: z.object({
        signerId: z.string().uuid(),
    }),
});
export const AUDIT_TRAIL_SIGNER_SIGNING_EXPIRED = 'signer.signing.session.expired';
export const auditTrailSignerSigningExpiredSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGNER_SIGNING_EXPIRED),
    payload: z.object({
        value: z.string(),
    }),
});
export const AUDIT_TRAIL_SIGNING_CANCELLED = 'signing.cancelled';
export const auditTrailSigningCancelledSchema = z.object({
    action: z.literal(AUDIT_TRAIL_SIGNING_CANCELLED),
    payload: z.object({
        userName: z.string(),
    }),
});
export const AUDIT_TRAIL_REVIEW_EXPIRED = 'review.expired';
export const auditTrailReviewExpiredSchema = z.object({
    action: z.literal(AUDIT_TRAIL_REVIEW_EXPIRED),
    payload: z.object({}),
});
export const AUDIT_TRAIL_REVIEW_APPROVED = 'review.approved';
export const auditTrailReviewApprovedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_REVIEW_APPROVED),
    payload: z.object({
        signingId: z.string().uuid(),
        reviewerName: z.string(),
    }),
});
export const AUDIT_TRAIL_REVIEW_REJECTED = 'review.rejected';
export const auditTrailReviewRejectedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_REVIEW_REJECTED),
    payload: z.object({
        signingId: z.string().uuid(),
        reviewerName: z.string(),
    }),
});
export const AUDIT_TRAIL_REPRESENTATIVES_NAMED = 'representatives.named';
export const auditTrailRepresentativesNamedSchema = z.object({
    action: z.literal(AUDIT_TRAIL_REPRESENTATIVES_NAMED),
    payload: z.object({
        companySignerId: z.string().uuid(),
        companyName: z.string(),
        namedBy: z.object({
            email: z.string(),
        }),
        representatives: z.array(z.object({
            signerId: z.string().uuid(),
            name: z.string(),
            email: z.string(),
            phone: z.string().optional(),
        })),
    }),
});
// When you add a new audit trail action, remember to add an icon too in
// backend-js/src/services/audit-trail-export/audit-trail-icons.ts
// backend-js/src/services/audit-trail-export/audit-trail-exporter.ts
export const auditTrailDetailsSchema = z.discriminatedUnion('action', [
    auditTrailDocumentViewedSchema,
    auditTrailDocumentDownloadedSchema,
    auditTrailSigningStartedSchema,
    auditTrailSignStartedSchema,
    auditTrailSignAbortedSchema,
    auditTrailSigningExpiredSchema,
    auditTrailSigningCompletedSchema,
    auditTrailSignerSigningExpiredSchema,
    auditTrailSigningCancelledSchema,
    auditTrailReviewExpiredSchema,
    auditTrailReviewApprovedSchema,
    auditTrailReviewRejectedSchema,
    auditTrailRepresentativesNamedSchema,
]);
export const auditTrailRecordSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    requestId: z.string().uuid(),
    ipAddress: z.string().nullable(),
    userId: z.string().uuid().nullable(),
    data: auditTrailDetailsSchema,
});
